import Api from '../../../api/api'

export const sendFile = (endpoint, file) => {
  const formData = new FormData()
  file.forEach((file) => formData.append('egresso_file', file))
  const resp = Api.post(endpoint, formData)
  return resp
}
